import { DemoCase, DemoCaseReferenceReport } from "~/api/model";

export type EvaluationOption = {
  demoCaseId: string;
  referenceReport: DemoCaseReferenceReport;
};

export const isDemoCaseMatch = (
  demoCase: Pick<DemoCase, "caseName" | "folderName">,
  caseName: string
): boolean =>
  demoCase.caseName === caseName || demoCase.folderName === caseName;

export const getEvaluationOptions = (
  demoCases: DemoCase[] | undefined,
  caseName: string
): EvaluationOption[] =>
  (demoCases ?? [])
    .filter((demoCase) => isDemoCaseMatch(demoCase, caseName))
    .flatMap((demoCase) =>
      (demoCase.referenceReports ?? []).map((referenceReport) => ({
        demoCaseId: demoCase.id,
        referenceReport,
      }))
    );
